/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as ViewTokenRouteImport } from './routes/view.$token'

const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewTokenRoute = ViewTokenRouteImport.update({
  id: '/view/$token',
  path: '/view/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/error': typeof ErrorRoute
  '/view/$token': typeof ViewTokenRoute
}
export interface FileRoutesByTo {
  '/error': typeof ErrorRoute
  '/view/$token': typeof ViewTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/error': typeof ErrorRoute
  '/view/$token': typeof ViewTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/error' | '/view/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/error' | '/view/$token'
  id: '__root__' | '/error' | '/view/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ErrorRoute: typeof ErrorRoute
  ViewTokenRoute: typeof ViewTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/view/$token': {
      id: '/view/$token'
      path: '/view/$token'
      fullPath: '/view/$token'
      preLoaderRoute: typeof ViewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  ErrorRoute: ErrorRoute,
  ViewTokenRoute: ViewTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
